// extracted by mini-css-extract-plugin
export var container = "_a0-0";
export var icon = "_a0-1";
export var text = "_a0-2";